export const convertToLatinNumerals = (persianDate: string): string => {
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const latinDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  return persianDate.replace(/[۰-۹]/g, match => latinDigits[persianDigits.indexOf(match)]);
};
const today = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return encodeURIComponent(`${year}-${month}-${day}`);
};
export const gregorianMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
export default {
  today
};

export function toGregorian(jy: number, jm: number, jd: number): [number, number, number] {
  let gy: number;
  if (jy > 979) {
    gy = 1600;
    jy -= 979;
  } else {
    gy = 621;
  }

  let days =
    365 * jy +
    Math.floor(jy / 33) * 8 +
    Math.floor(((jy % 33) + 3) / 4) +
    78 +
    jd +
    (jm < 7 ? (jm - 1) * 31 : (jm - 7) * 30 + 186);

  gy += 400 * Math.floor(days / 146097);
  days %= 146097;

  let leap = true;
  if (days > 36524) {
    gy += 100 * Math.floor(--days / 36524);
    days %= 36524;

    if (days >= 365) days++;
    else leap = false;
  }

  gy += 4 * Math.floor(days / 1461);
  days %= 1461;

  if (days > 365) {
    gy += Math.floor((days - 1) / 365);
    days = (days - 1) % 365;
    leap = false;
  } else {
    leap = true;
  }

  let gd = days + 1;
  const sal_a = [0, 31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  let gm: number;
  for (gm = 1; gm <= 12; gm++) {
    if (gd <= sal_a[gm]) break;
    gd -= sal_a[gm];
  }

  return [gy, gm, gd];
}

export function toGregorianString(jalaliDate: string, delimiter: '/' | '-' = '/'): string {
  const cleanDate = jalaliDate.replace(/-/g, '/');
  const parts = cleanDate.split('/');
  if (parts.length !== 3) return '';
  const [jy, jm, jd] = parts.map(Number);
  const [gy, gm, gd] = toGregorian(jy, jm, jd);
  return [gy, String(gm).padStart(2, '0'), String(gd).padStart(2, '0')].join(delimiter);
}
export function isGregorianBeforeToday(dateStr: string): boolean {
  const cleanDate = dateStr.replace(/-/g, '/');
  const [year, month, day] = cleanDate.split('/').map(Number);

  const inputDate = new Date(year, month - 1, day);

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  return inputDate < today;
}
